import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatHeading } from "blocks-nextjs/blocks-react/components/Heading/Heading";
import { CatIconSuccessFilled } from "blocks-nextjs/blocks-react/components/Icons/SuccessFilled/SuccessFilled";
import { CatToast } from "blocks-nextjs/blocks-react/components/Toast/Toast";
import React, { useEffect } from "react";
import "./CopyLinkToast.css";
const SharedLinkToast = ({ heading, message, onClose, show }) => {
    useEffect(() => {
        if (show) {
            const timer = setTimeout(() => {
                onClose();
            }, 4000);
            return () => clearTimeout(timer);
        }
    }, [show, onClose]);
    if (!show)
        return null;
    return (_jsx("div", { className: "fixed top-4 left-1/2 transform -translate-x-1/2 z-[99999] pointer-events-none max-w-[740px] w-[90%] h-auto px-4", children: _jsx("div", { className: "pointer-events-auto w-full h-full", children: _jsxs(CatToast, { delay: 4, onBlToastClose: onClose, variant: "success", children: [_jsx(CatIconSuccessFilled, { slot: "before" }), _jsxs("div", { children: [_jsx(CatHeading, { className: "link-copied-heading", variant: "label-sm", children: heading }), _jsx("p", { className: "link-copied-message", children: message })] })] }) }) }));
};
export default SharedLinkToast;
